import { EmployeeBeneficiaryStatus, EmployeeStatus } from '@cpce/shared';
import { BadgeColor } from '@/components/Badge';
import type { BadgeOption } from '@/components/table/table.types';

export const EMPLOYEE_STATUS_DISPLAY: Record<EmployeeStatus, { label: string; color: BadgeColor }> =
  {
    [EmployeeStatus.salaried]: { label: 'Salarié', color: BadgeColor.BLUE },
    [EmployeeStatus.internship]: { label: 'Stagiaire', color: BadgeColor.GRAY },
    [EmployeeStatus.retired]: { label: 'Retraité', color: BadgeColor.PURPLE },
  };

export const EMPLOYEE_STATUS_OPTIONS: BadgeOption<EmployeeStatus>[] = (
  Object.entries(EMPLOYEE_STATUS_DISPLAY) as [
    EmployeeStatus,
    { label: string; color: BadgeColor },
  ][]
).map(([value, display]) => ({ value, ...display }));

// Tolerates unknown/missing statuts (external billetterie data) by returning undefined rather than
// crashing on an out-of-enum value.
export function getEmployeeStatusDisplay(
  status: string | null | undefined
): { label: string; color: BadgeColor } | undefined {
  if (status && status in EMPLOYEE_STATUS_DISPLAY) {
    return EMPLOYEE_STATUS_DISPLAY[status as EmployeeStatus];
  }
  return undefined;
}

export const RELATIONSHIP_OPTIONS: BadgeOption<EmployeeBeneficiaryStatus>[] = [
  { value: EmployeeBeneficiaryStatus.married, label: 'Conjoint', color: BadgeColor.BLUE },
  { value: EmployeeBeneficiaryStatus.child, label: 'Enfant', color: BadgeColor.ORANGE },
];
